import React from "react";
import { useUserProfile } from "../../../contexts/UserProfileContext";
import PublicUserProfile from "../sections/PublicUserProfile";

const UserProfilePostsTab = () => {
  const { publicProfileProps } = useUserProfile();
  if (!publicProfileProps) return null;
  return <PublicUserProfile {...publicProfileProps} activeSection="posts" />;
};

export default UserProfilePostsTab;
